// SPDX-FileCopyrightText: Copyright 2025 OP Financial Group (https://op.fi). All Rights Reserved.
//
// SPDX-License-Identifier: LicenseRef-OpAllRightsReserved

/* eslint-disable max-len*/

export const SERVLET_CONTEXT = '/e-service-agreement/rest';

export const returnLink: string = '/corporate-customers/insurance/services/web-service-for-corporate-insurances';

export const APP_NAME = 'eService-agreement';

/** ID of the applications root DOM element */
export const APP_ROOT_ID = APP_NAME + '-root';

export const termsAndConditionsUrl: Map<string, string> = new Map([
    [
        'fi',
        'https://tuoteasiakirjat.op.fi/pds?link=ecb_00ce6774bfaf63f2b31555036a49594b100ec34bd599520f1a0bd773dae588226cf8a8c428e3e2630f0b05115434c424b33b16ea_iv_3e11668dac2336fb69185c7b',
    ],
    [
        'en',
        'https://tuoteasiakirjat.op.fi/pds?link=ecb_b34cb58cd8cf0e40f1eb1ebf9030d4cea5b39c99f9ff7c72fe833dbc2bb57c8fbc9c7890dcb4daea9b37f2f9b56009f64b8f31ec_iv_963ce4dcab975e8eb0ec3748',
    ],
    [
        'sv',
        'https://tuoteasiakirjat.op.fi/pds?link=ecb_f094d3c33d7e62ce289845a40515ebfebb466722ec5b21004da18749931353ed80c5e2d48e1b5f19690b28ca852c9f9a3f6b589e_iv_eef0f920673293c59e86998f',
    ],
]);

/** Maximum number of administrators that can be added to the form */
export const MAX_ADMINISTRATORS = 10;

//This order should be kept everywhere in the UI
export const companyTypes: readonly string[] = ['company', 'broker', 'accounting', 'propertyManagement'] as const;

export const AgreementTypes = {
    COMPANY: 'company',
    BROKER: 'broker',
    ACCOUNTING: 'accounting',
    PROPERTYMGMT: 'propertyManagement',
} as const;

export const pageRoutes = {
    firstPage: '/',
    infoPreview: '/preview',
    tupasLogin: '/tupasLogin',
    manualSigning: '/manualSigning',
    thankYou: '/thankYou',
    error: '/error',
} as const;

export const id = {
    BUSINESS_ID: 'companyBusinessId',
    COMPANY_NAME: 'companyName',
    STREET_ADDRESS: 'streetAddress',
    POSTAL_CODE: 'postalCode',
    CITY_TOWN: 'cityTown',
    PHONE: 'phone',
    COMPANY_TYPE: 'companyType',
    ALERT_NOTIFICATION: 'alertNotification',
    FIRST_NAME: 'firstName',
    LAST_NAME: 'lastName',
    PERSONAL_CODE: 'personalCode',
    ADMIN_PHONE_NUMBER: 'adminPhoneNumber',
    EMAIL: 'email',
    APPROVE_TERMS: 'approveTerms',
    ADDITIONAL_SIGNATORY_SELECTION: 'additionalSignatorySelection',
    ADDITIONAL_SIGNATORY_FIRST_NAME: 'additionalFirstNameInput',
    ADDITIONAL_SIGNATORY_LAST_NAME: 'additionalLastNameInput',
    ADDITIONAL_SIGNATORY_PHONE: 'additionalPhoneInput',
    ADDITIONAL_SIGNATORY_EMAIL: 'additionalEmailInput',
    SERVICE_CHECKBOX: 'adminSelectedServiceCheckbocx',
    IS_FOREIGN_COMPANY: 'isForeignCompany',
    COUNTRY: 'country',
    ADMIN_MAX_COUNT: 'adminMaxCount',
} as const;
